<template>
  <div id="contendor-contrato-programa-main">
    <v-toolbar v-if="!soloLectura" flat color="transparent">
      <v-spacer></v-spacer>
      <custom-button
        v-if="mixValidaScopesActions(1)"
        label="Nuevo"
        iconText="mdi-plus"
        tipo="agregar"
        @click="registrarNuevoPrograma"
        :disabled="listadoContratoProgramasObra.length > 0">
      </custom-button>
    </v-toolbar>
    <template v-if="listadoContratoProgramasObra.length > 0">
      <div
        v-for="{ id, programa } in listadoContratoProgramasObra"
        :key="`programa-${id}`">
        <v-card flat>
          <v-toolbar flat>
            <v-toolbar-title
              class="secondary--text">
              Programa de obra
            </v-toolbar-title>
            <v-tooltip
              v-if="!soloLectura && mixValidaScopesActions(3)"
              top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="preEliminarPrograma(id)">
                  <v-icon>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <span>
                Eliminar programa
              </span>
            </v-tooltip>
            <v-spacer></v-spacer>
            <v-tooltip
              v-if="!soloLectura && mixValidaScopesActions(2)"
              top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  class="ml-2"
                  v-bind="attrs"
                  v-on="on"
                  @click="preEditarPrograma(programa)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </template>
              <span>
                Editar programa
              </span>
            </v-tooltip>
          </v-toolbar>
          <v-card-text>
            <!-- Loader -->
            <v-skeleton-loader
              v-if="$apollo.loading"
              type="table-heading, table-thead, table-tbody"
            ></v-skeleton-loader>
            <listado
              v-if="!$apollo.loading"
              :programa="programa"
              :solo-lectura="soloLectura">
            </listado>
          </v-card-text>
        </v-card>
        <v-card flat color="transparent">
          <v-card-actions>
            <div class="font-weight-medium base6--text title">
              <span>Restante:</span>
              {{ catalogoCuadrado(programa) | currency }}
            </div>
            <v-spacer></v-spacer>
            <div class="secondary--text font-weight-medium title">
              <span>
                {{ sumaPrograma(programa) | currency }}
              </span>
            </div>
          </v-card-actions>
        </v-card>
      </div>
    </template>
    <template v-else>
      <v-card flat>
        <v-card-text>
          <v-row justify="center" align="center">
            <v-alert type="info"> No se ha registrado un programa. </v-alert>
          </v-row>
        </v-card-text>
      </v-card>
    </template>
    <v-dialog v-model="mostrarRegistrarNuevoPrograma" persistent width="650">
      <nuevo
        :contrato="getContrato"
        v-on:cerrar="cerrarVentana">
      </nuevo>
    </v-dialog>
    <v-dialog v-model="mostrarEditarPrograma" persistent width="650">
      <editar
        v-if="mostrarEditarPrograma"
        :contrato="getContrato"
        :programaExistente="programaDeObra"
        v-on:cerrar="cerrarVentana">
      </editar>
    </v-dialog>
    <v-dialog
      v-if="idPrograma"
      v-model="mostrarEliminarPrograma"
      width="450"
      persistent>
      <eliminar-todo-programa
        :id-programa="idPrograma"
        :id-contrato="getContrato.id"
        v-on:cerrar="cerrarVentana">
      </eliminar-todo-programa>
    </v-dialog>
    <v-dialog
      v-if="estePrograma"
      v-model="mostrarEliminarRegistroPrograma"
      width="450">
      <eliminar-programa
        :programaObraEliminar="estePrograma"
        :idContrato="getContrato.id"
        v-on:cerrar="cerrarVentana"/>
    </v-dialog>
  </div>
</template>

<script>
import CONTRATO from '@/graphql/querys/administracion/contratos/contrato.gql';
import CONTRATO_PROGRAMAS_OBRA from '@/graphql/querys/administracion/contratos/programa/contratoProgramasObra.gql';
import CustomButton from '@/components/buttons/Button.vue';
import Nuevo from '@/components/administracion/contratos/contrato/programa/Nuevo.vue';
import Editar from '@/components/administracion/contratos/contrato/programa/Editar.vue';
import EliminarTodoPrograma from '@/components/administracion/contratos/contrato/programa/EliminarPrograma.vue';
import EliminarPrograma from '@/components/administracion/contratos/contrato/programa/Eliminar.vue';
import Listado from './listado/Main.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ContratoProgramaMain',
  props: {
    soloLectura: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    Nuevo,
    Editar,
    CustomButton,
    Listado,
    EliminarPrograma,
    EliminarTodoPrograma,
  },
  data() {
    return {
      mostrarRegistrarNuevoPrograma: false,
      mostrarEditarPrograma: false,
      mostrarEliminarPrograma: false,
      mostrarEliminarRegistroPrograma: false,
      estePrograma: null,
      idPrograma: null,
      programaDeObra: {
        idContrato: this.$route.params.idContrato,
        programa: [],
      },

    };
  },
  methods: {
    registrarNuevoPrograma() {
      if (this.listadoContratoProgramasObra.length > 0) return;
      this.mostrarRegistrarNuevoPrograma = !this.mostrarRegistrarNuevoPrograma;
    },
    preEditarPrograma(programa) {
      const { idContratoProgramaObra } = programa[0];
      this.programaDeObra = {
        idContrato: this.getContrato.id,
        idContratoProgramaObra,
        programa,
      };
      this.mostrarEditarPrograma = !this.mostrarEditarPrograma;
    },
    preEliminarPrograma(id) {
      if (this.listadoContratoProgramasObra.length <= 0) return;
      this.mostrarEliminarPrograma = true;
      this.idPrograma = id;
    },
    sumaPrograma(programa) {
      return this.$ObjSumar(programa, 'monto');
    },
    catalogoCuadrado(programa) {
      const importeContratado = this.$numberRound((this.importeContrato
      + this.getContratoImporteModificado));
      return (
        importeContratado - this.sumaPrograma(programa)
      );
    },
    cerrarVentana() {
      this.mostrarRegistrarNuevoPrograma = false;
      this.mostrarEliminarPrograma = false;
      this.mostrarEliminarPrograma = false;
      this.mostrarEditarPrograma = false;
      this.idPrograma = null;
      this.estePrograma = null;
    },
  },
  apollo: {
    contrato: {
      query: CONTRATO,
      variables() {
        return {
          id: this.$route.params.idContrato,
        };
      },
    },
    contratoProgramasObra: {
      query: CONTRATO_PROGRAMAS_OBRA,
      variables() {
        return {
          idContrato: this.$route.params.idContrato,
        };
      },
    },
  },
  computed: {
    getContrato() {
      if (!this.contrato) return {};
      return this.contrato;
    },
    importeContrato() {
      if (!this.contrato) return 0;
      if (this.contrato.esObraFinanciada) {
        return this.contrato.importeCostoDirecto;
      }
      return this.contrato.importe;
    },
    getTotalContratado() {
      if (!this.contrato) return 0;
      return this.importeContrato + this.getContratoImporteModificado;
    },
    getContratoImporteModificado() {
      if (this.contrato.esObraFinanciada) {
        return this.contrato.modificado.importeCostoDirecto;
      }

      return this.contrato.modificado.importe;
    },
    listadoContratoProgramasObra() {
      if (!this.contratoProgramasObra) return [];
      return this.contratoProgramasObra;
    },
  },
  mounted() {
    eventBus.$on('eliminar-contrato-programa', (programaContrato) => {
      this.estePrograma = programaContrato;
      this.mostrarEliminarRegistroPrograma = true;
    });
  },
};
</script>

<style lang="scss">
</style>
